export default "__VITE_ASSET__B24VhviO__"